import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { MessageBars } from '../Outils/MessageBars';
import { DefaultButton, PrimaryButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataOperation } from '../../data/DataOperation';
import { Data } from '../../data/Data';
import { FicheMandatCommercialisation } from '../Fiche/FicheMandatCommercialisation'
import PerimetreContext from '../../contexts/PerimetreContext';

/****************************************************************
 PROPS:

****************************************************************/

export class DetailsListMandatCommercialisation extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListMandatCommercialisationWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListMandatCommercialisationWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent = () => {
        return (<DetailsList
            items={this.state.items}
            columns={this.columns}
            onColumnHeaderClick={this._onColumnHeaderClick}
            selectionMode={SelectionMode.none}
        />);
    };

    constructor(props) {
        super(props);
        this.objetState = {
            idOperation: 0,
            items: [],

            idMandatSelected: 0,
            estTypeCompte: false,

            tri: '',

            redirection: false,

            onAffichePanelIdentification: false,
            onAfficheDialogCreerAPartirDe: false,
            onAfficheDialogLierOperations: false,
            onAfficheDialogDelierOperations: false,

            enCoursDeTraitement: false,
            messageEnCoursTraitement: null,

            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: ''
        };

        this.state = this.objetState;

        this.columns = this._getColumns();
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des opérations en cours'
        });

        let chargementOperation = DataOperation._chargementMandatCommercialisation(this.state.idOperation, this.state.tri);

        chargementOperation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);

                    this.setState({
                        items: listeItem,
                        enCoursDeTraitement: false,
                        hideMessageBarWarning: true,
                        warningMessage: '',
                        hideMessageBarError: true,
                        errorMessage: ''
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    };

    _recuperationPerimetre = () => {
        var verificationSiPerimetreExiste = Data._verificationSiPerimetreExiste();

        verificationSiPerimetreExiste
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let valeurRetour = responseFetch.reponseAPIobjet;
                    let idOperation = valeurRetour[0];

                    this.setState({ idOperation: idOperation }, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    };

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)

            }
        ];
    };

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );

    };

    _onAffichePanelDetail = (idMandatSelected, estTypeCompte) => {
        this.setState({ idMandatSelected, estTypeCompte, affichePanelDetail: true })
    }

    _onCachePanelDetail = () => {
        this.setState({ affichePanelDetail: false });
    }

    _getColumns = () => {
        const typeEiffage = 'MandatCommercialisationOperationEiffage';
        let columnsTemp = [];

        columnsTemp.push({
            key: 'NomSociete',
            name: 'Société',
            ariaLabel: 'Société',
            fieldName: 'nomSociete',
            minWidth: 75,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown'
        });
        columnsTemp.push({
            key: 'NomMandataire',
            name: 'Nom mandataire',
            ariaLabel: 'Nom mandataire',
            fieldName: 'nomMandataire',
            minWidth: 100,
            maxWidth: 300,
            isResizable: true
        });
        columnsTemp.push({
            key: 'Region',
            name: 'Région',
            ariaLabel: 'Région',
            fieldName: 'region',
            minWidth: 100,
            maxWidth: 120,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown'
        });
        columnsTemp.push({
            key: 'Agence',
            name: 'Agence',
            ariaLabel: 'Agence',
            fieldName: 'agence',
            minWidth: 75,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown'
        });
        columnsTemp.push({
            key: 'NomCommercial',
            name: 'Programme',
            ariaLabel: 'Programme',
            fieldName: 'nomCommercial',
            minWidth: 150,
            maxWidth: 180,
            isResizable: true
        });
        columnsTemp.push({
            key: 'Exclusivite',
            name: 'Allotement',
            ariaLabel: 'Allotement',
            fieldName: 'allotement',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span>{item.exclusivite ? 'X' : ''}</span>;
            }
        });
        columnsTemp.push({
            key: 'honoraireCommercialisation',
            name: 'Taux d\'honoraires',
            ariaLabel: 'Taux d\'honoraires',
            fieldName: 'honoraireCommercialisation',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span title={item.honoraireCommercialisation}>{item.honoraireCommercialisation}</span>;
            }
        });
        columnsTemp.push({
            key: 'NbLot',
            name: 'Nb lots',
            ariaLabel: 'Nombre de lots',
            fieldName: 'nbLot',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown'
        });
        columnsTemp.push({
            key: 'TypeProgramme',
            name: 'Type de produit',
            ariaLabel: 'Type de produit',
            fieldName: 'typeProgramme',
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            minWidth: 100,
            maxWidth: 120,
            isResizable: true
        });
        columnsTemp.push({
            key: 'Datedebut',
            name: 'Date début',
            ariaLabel: 'Date début',
            fieldName: 'dateDebut',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let dateFormated = Scriba.date().stringDateFormatCourt(item.dateDebut);
                return <span title={dateFormated}>{dateFormated}</span>;
            }
        });
        columnsTemp.push({
            key: 'Datefin',
            name: 'Date fin',
            ariaLabel: 'Date fin',
            fieldName: 'dateFin',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let dateFormated = Scriba.date().stringDateFormatCourt(item.dateFin);
                return <span title={dateFormated}>{dateFormated}</span>;
            }
        });
        columnsTemp.push({
            key: 'StatutMandat',
            name: 'Statut',
            ariaLabel: 'Statut',
            fieldName: 'statutMandat',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown'
        });
        columnsTemp.push({
            key: 'Action',
            name: 'Action',
            ariaLabel: 'Statut',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                const idMandat = item.idMandat;
                const estTypeCompte = item.typeMandat == typeEiffage;
                return <IconButton
                    iconProps={{ iconName: 'Zoom' }}
                    title="Afficher le détail du mandat de commercialisation"
                    ariaLabel="Afficher le détail du mandat"
                    onClick={() => this._onAffichePanelDetail(idMandat, estTypeCompte)}
                />;
            }
        });

        return columnsTemp;

    }

    componentDidMount = () => {
        this._recuperationPerimetre();
    };

    //componentDidUpdate = (prevProps, prevState) => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");

    //        this._recuperationPerimetre();
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._recuperationPerimetre();
    };

    componentWillUnmount = () => {
    };

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    //items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <FicheMandatCommercialisation
                idMandat={this.state.idMandatSelected}
                estTypeCompte={this.state.estTypeCompte}
                onFerme={this._onCachePanelDetail}
                estAffiche={this.state.affichePanelDetail}
            />

        </Fragment>;
    };

}